import { Indexed } from '../database/dao/Indexed';
import { NaturalPK } from '../database/dao/NaturalPK';
import { WorkOrder } from './WorkOrder';

export class LoggedUser implements NaturalPK, Indexed {
    id: string;
    name: string;
    email: string;
    role: string;
    workOrders: WorkOrder;
    creationDate: Date;

    constructor(id: string, name: string, email: string, role: string, workOrders: WorkOrder, creationDate: Date) {
        this.id = id;
        this.name = name;
        this.email = email;
        this.role = role;
        this.workOrders = workOrders;
        this.creationDate = creationDate;
    }

    getFields(): string[] {
        return ['id'];
    }

    getIndexes(): any[] {
        return [
            { name: 'id', fields: ['id'] },
            { name: 'name', fields: ['name'] },
        ];
    }
}
Object.defineProperty(LoggedUser, 'name', { writable: true });
let x = 'name';
LoggedUser[x] = 'LoggedUser';
